module.exports = __webpack_public_path__ + "static/media/bubbles.4663c752.mp3";